// This is only needed for backwards compatibility and will be removed in the
// next major release of ember-simple-auth. Unfortunately, there is no way to
// deprecate this without hooking into Ember's internals…
export default {
  name: 'ember-simple-auth',

  initialize() {}
};
